/**
 * 应用入口
 */
import Vue from 'vue'
// import fastclick from 'fastclick'

import App from '$components/App'
import router from '$routes'
import store from '$stores'

import MintUI from 'mint-ui' // 饿了么移动端UI组件
import ConfirmPlugin from '@finance/ssvue/src/plugins/confirm'
import CollectPlugin from '@finance/ssvue/src/plugins/collect'
import ToastPlugin from '@finance/ssvue/src/plugins/toast'
import AlertPlugin from '@finance/ssvue/src/plugins/alert'
import VueAwesomeSwiper from 'vue-awesome-swiper' // swiper滑动组件

import 'swiper/dist/css/swiper.css'
import './lib/ArrayFind' // array.prototype.find 模拟，低版本移动浏览器不支持

// fastclick.attach(document.body)

// 组件声明
import SeckillIcon from './components/SeckillIcon'

Vue.component('SeckillIcon', SeckillIcon)

// 生产环境不显示警告
Vue.config.productionTip = false

/* =====导入ssvue插件===== */
Vue.use(CollectPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

/* =====滑动===== */
Vue.use(MintUI)
Vue.use(VueAwesomeSwiper)

/* =====引入调试工具===== */
if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'dev') {
  require('vconsole')
  require('./utils/debug-login')
}

/* ===== 错误日志，测试环境与vconsole冲突 ===== */
// const currentScript = document.currentScript && document.currentScript.src
// Vue.config.errorHandler = (error) => {
//   window._mntError && window._mntError.push({
//     jsLink: currentScript,
//     info: error.message,
//     error
//   })
// }

/* =====创建vue实例===== */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/app.js